<ng-select name="hotel"
           bindValue="id"
           bindLabel="name"
           [multiple]="true"
           [items]="hotels"
           appendTo="body"
           [virtualScroll]="true"
           [(ngModel)]="selectedHotels"
           [placeholder]="placeholder | translate">
  <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
    <div class="ng-value" *ngFor="let item of items | slice:0:1">
      <span class="ng-value-label">{{ $any(item).name }}</span>
      <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
    </div>
    <div class="ng-value" *ngIf="items.length > 1">
      <span class="ng-value-label">+{{ items.length - 1 }}</span>
    </div>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <app-search-picker-option
      [name]="item.name"
      [additionalInfo]="item | hotelSelectorData">
    </app-search-picker-option>
  </ng-template>
</ng-select>
